import $ from 'jquery'

export default class ComponentFactory {
	static globalHandlers = {}

	static create(instance, element, loadDependencies = true) {
		const $el = $(element)
		const ref = new instance($el)

		/**
		 * The instance is stored on the DOM node(s), not on the jQuery wrapper,
		 * so Block.isValidBlock() can see it after initialisation
		 */
		$el.each((index, node) => {
			node.ref = ref
		})

		/**
		 * Global handlers can be used whenever a component is subscribed an a callback on the window
		 */
		if (typeof ref.getGlobalHandler === 'function') {
			const [method, callback] = ref.getGlobalHandler()
			if (this.globalHandlers[method]) {
				this.globalHandlers[method] = [...this.globalHandlers[method], callback]
			} else {
				this.globalHandlers[method] = [callback]
			}
		}

		Object.keys(this.globalHandlers).map((method) => {
			window[method] = () => {
				this.globalHandlers[method].forEach((callback) => callback())
			}
		})

		/**
		 * Some components require dependencies, for example google maps API
		 */
		if (loadDependencies && typeof ref.getDependency === 'function') {
			const firstScriptTag = $('script').get(0)
			const tag = document.createElement('script')
			tag.defer = true
			tag.async = true
			if (typeof ref.load === 'function') {
				tag.onload = ref.load.bind(ref)
			}
			tag.src = ref.getDependency()
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
		}

		return ref
	}
}
